import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Link } from "react-router-dom";

function OurWork() {
  const dispatch = useDispatch();
  const get_our_work_list = useSelector((state) =>
    state?.allapi?.get_our_work_list ? state?.allapi?.get_our_work_list : {}
  );

  const ourWorklist = get_our_work_list?.sliders
    ? get_our_work_list?.sliders
    : [];

  useEffect(() => {
    dispatch(allapiAction.getourwork({ page: "home" }));
  }, []);

  useEffect(() => {
    const cards = document.querySelectorAll(".featured-product-card");

    cards.forEach((card) => {
      const field = document.createElement("div");
      field.className = "featured-particles-field";
      card.appendChild(field);

      for (let i = 0; i < 25; i++) {
        const particle = document.createElement("div");
        particle.className = "featured-particle";
        particle.style.setProperty("--x", `${Math.random() * 200 - 100}px`);
        particle.style.setProperty("--y", `${Math.random() * 200 - 100}px`);
        particle.style.animation = `particleFloat ${1 + Math.random() * 2}s infinite ease-in-out`;
        particle.style.animationDelay = `${Math.random() * 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        field.appendChild(particle);
      }
    });
  }, []);

  return (
    <div className="featured-product-slider-container px-1 mt-4 feature-product-new">
      <div className="featured-product-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
        <h5 className="fw-bold featured-product-text mb-0">OUR WORK</h5>

        <Link className="text-decoration-none fw-bold featured-product-text" to="">
          View all
        </Link>

        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={15}
        autoplay={{ delay: 1800, disableOnInteraction: false }}
        loop={true}
        speed={1000}
        breakpoints={{ 320: { slidesPerView: 2 }, 768: { slidesPerView: 4 }, 1024: { slidesPerView: 6 } }}
      >
        {ourWorklist.map((data) => (
          <SwiperSlide key={data?._id}>
            <div className="featured-product-card tilt">
              <div className="img-box">
                <img
                  src={URL?.API_BASE_URL + data?.image}
                  alt={data?.title}
                />
              </div>

              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>
              <span className="mannu-bhai"></span>

              <div style={{ lineHeight: "0.6" }}>
                <p>
                  {data?.title?.length > 18
                    ? data?.title?.substring(0, 18) + "..."
                    : data?.title}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default OurWork;
